import axios from 'axios';
import { railsConfig } from '../API/railsConfig';

export const ENABLE_CLARITY_CFGKEY = 'rails_dweb_enable_clarity_script';
export const IRCTC_NEW_USER_REGISTRATION_URL = 'irctc_newuser_registration_url_desktop';
export const RAILS_TG_FC_TOGETHER_TEXT_CONFIG = 'rails_tg_fc_together_text_config_dweb';
export const LOGIN_PERSUASSUION_CONFIG = 'dweb_traveller_login_persuasion';
export const DWEB_AADHAR_MODAL_TEXT = 'dweb_aadhar_modal_text';
export const DWEB_FC_TG_CONFIGKEY = 'rails_dweb_fc_tg_config';

export const RAILS_DWEB_FC_TG_CONFIG_FALLBACK = {
  tgHeader:
    'Trip Guarantee is now Alternate Trip Plan - Get a Confirmed Ticket or 3X Refund',
  tgFilterText: 'Alternate Trip Plan (previously Trip Guarantee)',
  fcHeader: 'Free Cancellation',
  fcSubHeader:
    'Pay zero railway cancellation charges when ticket is cancelled.',
  fcValidity: 'Free cancellation valid till chart preparation.',
  knowMore: 'Know more',
  approxRefund: 'Refund when you cancel your ticket:',
  added: 'added',
  addFc: 'Add Free Cancellation for',
  tgSubHeader: '',
  tgUsage: 'Use this voucher to book flight, cab, bus or train.',
  tgTnc:
    ' Waitlisted bookings are eligible for a 3X refund. RAC is treated as confirmed, as travel is allowed with RAC tickets. ',
  addTg: 'Add Alternate Trip Plan for',
  tgOptOut: 'I don’t want Alternate Trip Plan',
  fcOptOut: 'I don’t want Free Cancellation',
  fcDiscountOptOut: 'Skip Free Cancellation',
  buyTg: 'Buy Alternate Trip Plan for',
  buyFc: 'Add Free Cancellation for',
  buyFcDiscount: 'Buy Free Cancellation @',
  fcToast:
    'Free Cancellation added to your ticket. You can add only one out of Alternate Trip Plan and Free Cancellation.',
  fcToastV2: 'Free Cancellation added to your ticket.',
  tgToast:
    'Alternate Trip Plan added to your ticket. You can add only one out of Alternate Trip and Free Cancellation.',
  tgToastV2: 'Alternate Trip Plan added to your ticket',
  errorMsg:
    'Do you wish to add Free Cancellation or Alternate Trip Plan to your trip?'
};

export const RAILS_TG_FC_TOGETHER_TEXT_CONFIG_FALLBACK = {
  TG: {
    header: 'Get a Confirmed Ticket or 3X Refund',
    subHeader: 'With Alternate Trip (previously Trip Guarantee)',
    tgFilterText: 'Alternate Trip (previously Trip Guarantee)',
    refunds: [
      {
        label: '1x Refund',
        title: 'Ticket fare = ',
        refund: 1,
        description: 'will be refunded to',
        refundMode: 'original paymode'
      },
      {
        label: '2x Refund',
        title: 'Ticket Fare x 2',
        refund: 2,
        description: 'will be refunded as',
        refundMode: 'MMT Voucher'
      }
    ],
    approxRefund: 'Refund = ',
    usages: [
      'Use this voucher to book flight, cab, bus or train.',
      'Waitlisted bookings are eligible for a 3X refund. RAC is treated as confirmed, as travel is allowed with RAC tickets. '
    ],
    tncCTA: 'Know more',
    checkBoxCTA: 'Add Alternate Trip for ₹{price}/person',
    checkBoxCTASelected: 'Alternate Trip added for ₹{price}/person',
    ctaYes: 'Buy Alternate Trip @ ₹{price}/person',
    ctaNo: 'I don’t want to guarantee my trip',
    toast:
      'Congratulations! Alternate Trip attached and Free Cancellation removed from your booking',
    tncCTARacPremiumLink:
      'https://www.makemytrip.com/promos/trains-trip-guarantee.html?popup=noShow&cta=noShow',
    tncCTALink:
      'https://www.makemytrip.com/promos/trains-trip-guarantee.html?popup=noShow&cta=noShow',
    usagesRacPremium: [
      'Use this voucher to book flight, cab, bus or train.',
      'Waitlisted bookings are eligible for a 3X refund. RAC is treated as confirmed, as travel is allowed with RAC tickets. '
    ]
  },
  FC: {
    header: 'Free Cancellation',
    subHeader: 'Pay zero charges when ticket is cancelled.',
    approxRefund: 'Refund per passenger when you cancel your ticket:',
    description: 'Free cancellation valid till chart preparation. ',
    tncCTA: 'Know more',
    checkBoxCTA: 'Add Free Cancellation for ₹{price}/person ',
    checkBoxCTASelected: 'Free Cancellation added for ₹{price}/person ',
    ctaYes: 'Buy Free Cancellation @ ₹{price}/person ',
    ctaNo: 'Skip Free Cancellation',
    toast:
      'Congratulations! Free Cancellation attached and Alternate Trip removed from your booking',
    toastNew: 'Free Cancellation added to your Trip!'
  },
  FC_TG_DISCOUNT: {
    fcDiscountText: '<p><b>COMBO OFFER: Extra ₹99 OFF</b></p>',
    tgDiscountText: '<p><b>COMBO OFFER: Extra ₹99 OFF</b></p>',
    fcTgDiscountText: '<p><b>₹99 SAVED USING COMBO OFFER</b></p>',
    fcBottomSheetDiscountText:
      '<p><b>COMBO OFFER: Extra ₹99 OFF</b> on Free Cancellation</p>',
    tgBottomSheetDiscountText:
      '<p><b>COMBO OFFER: Extra ₹99 OFF</b> on Alternate Trip</p>',
    fcBottomSheetButtonText:
      '<p>Buy Free Cancellation @ <a>₹99</a> ₹{price}/person </p>',
    tgBottomSheetButtonText:
      '<p>Buy Alternate Trip @ <a>₹99</a> ₹{price}/person </p>',
    tgCheckBoxCTA:
      '<p>Add Alternate Trip for <a>₹99</a> <b>₹{price}/person</b></p>',
    fcCheckBoxCTA:
      '<p>Add Free Cancellation for <a>₹99</a> <b>₹{price}/person</b></p>',
    fcCheckBoxCTASelected:
      '<p>Free Cancellation added for <a>₹99</a> <b>₹{price}/person</b></p>',
    tgCheckBoxCTASelected:
      '<p>Alternate Trip added for <a>₹99</a> <b>₹{price}/person</b></p>'
  },
  FC_TG_DISCOUNT_V2: {
    fcDiscountText: '<p><b>COMBO OFFER: Extra ₹{discount} OFF</b></p>',
    tgDiscountText: '<p><b>COMBO OFFER: Extra ₹{discount} OFF</b></p>',
    fcTgDiscountText: '<p><b>₹{discount} SAVED USING COMBO OFFER</b></p>',
    fcBottomSheetDiscountText:
      '<p><b>COMBO OFFER: Extra ₹{discount} OFF</b> on Free Cancellation</p>',
    tgBottomSheetDiscountText:
      '<p><b>COMBO OFFER: Extra ₹{discount} OFF</b> on Alternate Trip</p>',
    fcBottomSheetButtonText:
      '<p>Buy Free Cancellation @ <a>₹{discount}</a> ₹{price}/person </p>',
    tgBottomSheetButtonText:
      '<p>Buy Alternate Trip @ <a>₹{discount}</a> ₹{price}/person </p>',
    tgCheckBoxCTA:
      '<p>Add Alternate Trip for <a>₹{discount}</a> <b>₹{price}/person</b></p>',
    fcCheckBoxCTA:
      '<p>Add Free Cancellation for <a>₹{discount}</a> <b>₹{price}/person</b></p>',
    fcCheckBoxCTASelected:
      '<p>Free Cancellation added for <a>₹{discount}</a> <b>₹{price}/person</b></p>',
    tgCheckBoxCTASelected:
      '<p>Alternate Trip added for <a>₹{discount}</a> <b>₹{price}/person</b></p>',
    fcCheckBoxCTASelectedCouponText:
      '<p>Added for <a>₹{discount}</a> <b>₹{price}/person</b></p>',
    tgCheckBoxCTASelectedCouponText:
      '<p>Added for <a>₹{discount}</a> <b>₹{price}/person</b></p>'
  },
  FC_SNACKBAR_DISCOUNT_TEXT: {
    fcSnackBarText:
      'Add Free Cancellation & Get Full Fare Refund @{discount}/person'
  }
};

const CFGKEY_VALUES = 'cfgKeyValue';

export const getConfigKey = async (cfgKey : string, fallback: any) => {
    let response = fallback;
    const headers = {
    'Authorization': 'Tect685j8xMpLJF',
    };
    const body = {
        cfgKey: cfgKey,
    }
    const storageResponse = await JSON.parse(sessionStorage.getItem(CFGKEY_VALUES));

    if (storageResponse?.[cfgKey]) {
        return storageResponse?.[cfgKey];
    }

    await axios.post(railsConfig.configStoreUrl, body, { headers })
    .then((res) => {
        if(res?.data?.configKeys?.length > 0) {
            response = res.data.configKeys[0]?.value;
        }
        let newStorageResponse = {
            ...storageResponse,
            [cfgKey]: response
        }
        sessionStorage.setItem(CFGKEY_VALUES, JSON.stringify(newStorageResponse));
    })
    .catch((err) => {
        console.log('Error in fetching value from configStore: ', err);
    });
    return response;
};
